<template>
  <div class="form-widget-split form-item">
    <div
      class="widget-item"
      :class="renderSence === 'edit' ? 'widget-item-border' : ''"
      :style="{ color: widget.textColor }"
    >
      <div class="form-widget-split-div"></div>
      <div
        v-if="widget.staticDefaultValue"
        class="form-widget-split-text"
      >{{ widget.staticDefaultValue }}</div>
      <div class="form-widget-split-div"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormWidgetSplit',
  props: {
    widget: {
      type: Object,
      required: true
    },
    renderSence: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.form-widget-split {
  .widget-item {
    padding: 0.857rem 1.143rem;
    background-color: $--app-light-color;
    display: flex;
    align-items: center;
    min-height: 20px;
    .form-widget-split-div{
      border-top: 1px dashed ;
      flex: 2 ;
    }
    .form-widget-split-text {
      max-width: 60%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .widget-item-border {
    border-bottom: 1px solid $--app-body-bgColor;
  }
}
</style>
